import {CheckCircleFilled} from "@ant-design/icons";
import {PaymentConst} from "../../../utils/payment";
import styles from "./style.module.scss";
import Rent from "./Rent";
import Sell from "./Sell";
import {useContext, useEffect, useLayoutEffect} from "react";
import PaymentContext from "../../../store/PaymentContext";
import {checkHasData} from "../util";
import {IProductDetailPayment} from "../../../@types/IProduct/IProductDetail";

const PaymentSuccess = () => {
    const {
        rentCarts,
        sellCarts,
        setCurrentStep,
        setSellCarts,
        setRentCarts,

        setRentTransportFee,
        setSellTransportFee,
    } = useContext(PaymentContext);


    const updateData = (carts: IProductDetailPayment[]) => {
        let newCarts = [];
        for (let item of carts)
        {
            if(!item.checked) {
                let cItem = {...item};
                if(item.accessories.length) {
                    let accessories = []
                    for(let acc of item.accessories)
                    {
                        if(!acc.checked) {
                            accessories.push(acc)
                        }
                    }

                    cItem.accessories = accessories;
                }

                newCarts.push(cItem);
            }
        }

        return newCarts;
    }

    // useLayoutEffect(() => {

    //     return () => {
    //         reloadPage()
    //     }
    // }, [])

    // const reloadPage = () => {
    //     setCurrentStep(1);
    //     setRentCarts(updateData(rentCarts));
    //     setSellCarts(updateData(sellCarts));
    //     setRentTransportFee(0)
    //     setSellTransportFee(0);
    // }

    // useEffect(() => {
    //     window.addEventListener("beforeunload", reloadPage);
    //     return () => {
    //         window.removeEventListener("beforeunload", reloadPage);
    //     };
    // }, []);

    return (
        <div className="w-full h-full">
            <div className="pt-4">
                <div className={`bg-white w-full py-2 justify-center items-center flex gap-0.5 text-lg ${ styles.textSuccess } `}>
                    <CheckCircleFilled style={{ color: PaymentConst.Color.success, fontSize: '1rem' }} className="w-20 md:w-auto" rev={undefined}/>
                    Đặt hàng thành công, thông tin đơn hàng đã được gửi về mail vui lòng kiểm tra thông tin tại mail
                </div>
            </div>

            <div className={`${ checkHasData(rentCarts) && checkHasData(sellCarts) ? 'pt-4 grid grid-cols-1 md:grid-cols-2 gap-4 px-4 md:px-20' : 'flex justify-center pt-4 px-4' }`}>
                <Rent />
                <Sell />
            </div>
        </div>
    )
}

export default PaymentSuccess;
